import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Divider } from 'components';
import { useMediaQuery } from '@mui/material';
import useTheme from '@mui/system/useTheme';
import { categoriesData } from './exploreCategoriesData';
import CategoryItem from './CategoryItem';
import {
  AdvisorCategoriesContainer,
  AllCategoriesButtonContainer
} from './styled';

function Categories(): JSX.Element {
  const theme = useTheme();
  return (
    <AdvisorCategoriesContainer>
      <Typography variant="h2" component="div" margin={0}>
        Explore Psychic Advisor Categories
      </Typography>
      <Grid
        className="categories-container"
        container
        alignContent="center"
        justifyContent="center">
        {categoriesData.map((item, index) => (
          <Grid
            className="category-item-container"
            item
            key={index}
            xs={12}
            sm={6}>
            <CategoryItem
              key={item.categoryName}
              categoryName={item.categoryName}
              description={item.description}
              link={item.link}
              iconName={item.iconName}
            />
          </Grid>
        ))}
      </Grid>

      <AllCategoriesButtonContainer>
        <Button variant="outlined" size="comfy" href="/all-categories">
          All Categories
        </Button>
      </AllCategoriesButtonContainer>

      <Divider sizePx={useMediaQuery(theme.breakpoints.up('sm')) ? 50 : 30} />
    </AdvisorCategoriesContainer>
  );
}

export default Categories;
